export const hasRenderableValue = (value: unknown): boolean =>
  typeof value === 'string' && value.trim() !== '';
